<script>
    import marked from 'marked'
    import { onMount, onDestroy } from "svelte"
    import { getFund } from "../api/fund.js"
    import Qr from "../Qr.svelte";
    import ReportForm from "../ReportForm.svelte";
    import IconButton from "../atoms/IconButton.svelte";
    import Button from "../atoms/Button.svelte";
    import Dialogue from "../molecules/Dialogue.svelte";
    import Shimmer from "../atoms/Shimmer.svelte";
    import CopyClipBoard from "../organisms/CopyClipBoard.svelte";
    import {toasts} from "../stores.js";

    export let params = {}

    let img;
    let imgSrc;
    let title = params.title
    let button_class = "huge curcular ui green icon button"
    let _navigator = navigator
    let donateAmountInput;

    $: if (img && imgSrc) {
        img.src = imgSrc
    }
    $: if (params.title != title) {
            location.reload()
    }

    $: donate = false;
    $: amount = null;
    $: donate_amount = false;
    $: sample_data = null
    $: revealed = false
    $: report = false
    $: percent = 4

    const handleDonate = () => {
        if (amount < 5.00) {
            toasts.pushToast("amount too small", "error");
            donateAmountInput.setSelectionRange(0, donateAmountInput.value.length);
        }
        else {
            donate_amount = false
            donate = true
        }
    }

    const copyUrl = async () => {
        const app = new CopyClipBoard({
            target: document.getElementById('clipboard'),
            props: { copyText: "http://localhost:5000/#/fund/" + title }
        })
        app.$on('success', () => toasts.pushToast("fund copied", "success"));
        app.$on('err', () => toasts.pushToast("error copying fund", "error"));
        app.$destroy();
    }

    onMount(async() => {
        let fund = await getFund(params.title);
        sample_data = fund;
        percent = (sample_data.donated / sample_data.goal) * 100 + "%";
        header = sample_data.title
    })

    fetch("http://172.81.181.23:3004/fundImage?fund_id=" + params.title, {
        headers: {"Authorization": "Basic womp"}
    })
    .then(async res => {
        let blob = await res.blob()
        imgSrc = URL.createObjectURL(blob)
    })
    .catch(err => console.log(err, "e"))
    $: header = "Plithos Fund"

    $: if(sample_data && sample_data.tite) {
        header = sample_data.title
    }
    $: if(donateAmountInput) {
        donateAmountInput.focus();
    }
    
    onDestroy(() => {
        document.title = "Plithos Fund";
    })

    function onKey(event) {
        if (event.keyCode == 13) {
            handleDonate();
        }
    }

</script>
<svelte:head>
    <title>{header}</title>
</svelte:head>

<div class="content">
    {#if sample_data != null}
        <h1>{sample_data.title}</h1>
        <div class="image-container">
            <img bind:this={img} class="banner" src="https://i.imgur.com/DA8VpEx.jpg"/>
        </div>
        <div id="clipboard"></div>
        <div class="donations">
            <h3 style="margin-top: 4px; margin-bottom: 0px;">
                {sample_data.totalDonors} {sample_data.totalDonors == 1 ? "donation" : "donations"}
            </h3>
            <div class="progress"  style="overflow: hidden;">
                <div style="width: {percent};" class="total-progress"/>
            </div>
            <p style="margin-top: 4px;">{sample_data.donated} / {sample_data.goal} BTC Raised</p>    
        </div>

        <div class="ui divider divy"></div>
        <div class="preview">{@html marked(sample_data.description)}</div>
        

        <div class="main">
        
            {#if report}
                <div class="modal">
                    <ReportForm fundId={params.title} on:close={() => report = false} fundTitle={sample_data.title}/>
                </div>
            {/if}

            {#if donate}
                <div class="modal">
                    <Qr 
                        on:close={() => donate = false} 
                        address="1BvBMSEYstWetqTFn5Au4m4GFg7xJaNVN2" 
                        price={amount}
                        fundTitle={params.title}
                        fundId={params.title}/>
                </div>
            {/if}

            {#if donate_amount}
                <Dialogue cancel on:close={() => donate_amount = false} on:okay={() => donate = true}>
                    <h4 style="margin-bottom: 1rem;">Enter Donation Amount</h4>
                    <div class="am">
                        <i class="ui icon dollar sign"/>
                        <input class="amount-input" bind:value={amount} placeholder="minimum 5"/>.00
                <div class="modal">
                    <div class="amount">
                        <h4>Enter Your Donation</h4>
                        <div class="am">
                            <i class="ui icon dollar sign"/>
                            <input 
                                class="amount-input" 
                                bind:this={donateAmountInput} 
                                bind:value={amount} 
                                on:keypress={onKey}
                                placeholder="minimum 5"/>.00
                        </div>
                        <div class="split-bar">
                            <button 
                                on:click={() => donate_amount = false}
                                style="margin-top: 0.4rem;"
                                class="fc b dim br2 ph3 pv2 mb2 dib white bg-brand-red"
                            >
                            Cancel
                            </button>
                            <button 
                                on:click={handleDonate}
                                style="margin-top: 0.4rem;"
                                class="fc b dim br2 ph3 pv2 mb2 dib white bg-brand-green"
                            >
                            Donate
                            </button>
                        </div>
                    </div>
                    <div style="height: 1rem;"></div>
                </Dialogue>
            {/if}

            {#if !donate && !report && !donate_amount}
                <div class="buttons">

                    {#if revealed}
                        <IconButton on:click={() => report = true} icon="flag" color="#F25F5C"/>
                        <div class="spacer"></div>
                        <IconButton on:click={() => copyUrl()} icon="share" color="#FFE066"/>
                        <div class="spacer"></div>
                        <IconButton on:click={() => donate_amount = true} icon="dollar sign" color="#17C3B2"/>
                        <div class="spacer"></div>
                    {/if}

                    <IconButton 
                        on:click={() => revealed = !revealed} 
                        icon={revealed ? "down angle":"up angle"} 
                        color="#3891FF"/>

                </div>
            {/if}

        </div>
    {:else}
        <div style="margin-block: 1.2em;">
            <Shimmer height="32px" width="50%"/>
        </div>
        <div class="image-container">
            <Shimmer height="100%" width="100%"/>
        </div>
        <div style="margin-top: 4px;">
            <Shimmer height="1.17em" width="20%"/>
        </div>
        <div class="progress"  style="overflow: hidden;">
            <div style="width: {0}%;" class="total-progress"/>
        </div>
        <div style="margin-top: 4px;">
            <Shimmer height="1.17em" width="20%"/>
        </div>
        <div class="ui divider divy"></div>
        <div style="margin-block: 1.2em;">
            <Shimmer height="32px" width="50%"/>
        </div>
        <div style="margin-top: 4px;">
            <Shimmer height="1.17em" width="75%"/>
        </div>
        <div style="margin-top: 4px;">
            <Shimmer height="1.17em" width="75%"/>
        </div>
        <div style="margin-top: 4px;">
            <Shimmer height="1.17em" width="50%"/>
        </div>
    {/if}
</div>

<style>
    .rotate {
        transform: rotate(180deg) translateY(-25%);
    }
    .spacer {
        height: 1rem;
    }
    .buttons {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: fixed;
        bottom: 1rem;
        right: 1rem;
        width: fit-content;
        height: 50%;
    }
    .donations {
        width: 100%;
    }
    .total-progress {
        height: 0.5rem;
        background-color: #17C3B2;
        border-radius: 1000px;
    }
    .progress {
        margin-top: 0.5rem;
        width: 100%;
        height: 0.5rem;
        background-color: #CCC;
        border-radius: 1000px;
    }
    .content {
        width: 100%;
    }
    .modal {
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .main {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .image-container{
        width: 100%;
        height: 25vh;
        display: flex;
        justify-content: center;
        background-color: black;
    }
    .banner {
        height: 100%;
        width: 100%;
        object-fit: contain;
    }
    @media only screen and (min-width: 768px) {
        .content {
            width: 44rem;
            align-self: center;
        }
        .image-container {
            height: 45vh;
        }
    }
    .amount {
        height: fit-content;
        display: flex;
        flex-direction: column;
        width: fit-content;
        padding: 1rem;
        background-color: white;
        border-radius: 1rem;
    }
    .amount-input {
        border: none;
        text-align: right;
        color: #333;
        padding-right: 0px;
        flex-grow: 1;
    }
    .amount-input:focus {
        border: none;
        outline: none;
    }
    .am {
        display: flex;
        border: 1px solid #ccc;
        height: fit-content;
        align-items: center;
        padding-right: 1rem;
        padding-left: 0.4rem;
        border-radius: 0.2rem;
    }
    .split-bar {
        display: flex;
        padding-top: 1rem;
        justify-content: space-around;
    }
    h4 {
        margin-top: 0px;
        margin-bottom: 0.4rem;
    }
</style>
